import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import Image from 'next/image'
import { useTranslation } from 'src/utils/i18n'

const UNLOCK_URL = 'https://iforgot.apple.com/unlock'

const AppleIdLockedModal = ({ open, onClose, onReverify, onContactUs }) => {
  const { t } = useTranslation('common')
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!open || !mounted) return null

  return createPortal(
    <div className="fixed bottom-0 left-0 right-0 top-[60px] z-[1315] flex items-center justify-center overflow-y-auto bg-[rgba(0,0,0,0.5)] px-4 py-4 smj:items-start smj:px-4 smj:pb-4 smj:pt-3 smjs:left-[300px]">
      <div className="relative my-auto flex w-full max-w-[544px] flex-col overflow-hidden rounded-[12px] bg-white shadow-[0px_6px_20px_0px_rgba(23,24,33,0.2)] smj:my-0 smj:max-h-[calc(100dvh-60px-28px)] lg:rounded-[16px]">
        <button
          type="button"
          aria-label="close"
          className="absolute right-3 top-3 z-[2] flex h-6 w-6 items-center justify-center text-[#9297AF]"
          onClick={onClose}
        >
          <span className="relative block h-4 w-4">
            <span className="absolute left-1/2 top-1/2 block h-[18px] w-[2px] -translate-x-1/2 -translate-y-1/2 rotate-45 rounded bg-current" />
            <span className="absolute left-1/2 top-1/2 block h-[18px] w-[2px] -translate-x-1/2 -translate-y-1/2 -rotate-45 rounded bg-current" />
          </span>
        </button>

        <div className="min-h-0 flex-1 overflow-y-auto px-4 py-6 lg:p-8">
          <div className="flex flex-col items-center gap-3 lg:gap-4">
            <Image
              src="/images/ios-locked/lock-icon.svg"
              alt=""
              width={48}
              height={48}
              className="h-12 w-12"
            />
            <div className="text-center">
              <h2 className="text-[20px] font-semibold leading-[28px] text-[#020417] lg:text-[24px] lg:leading-[36px]">
                {t('Apple ID locked')}
              </h2>
              <p className="mt-2.5 text-[16px] leading-6 text-[#020417]/80">
                {t('Your Apple ID was locked due to multiple failed password attempts Follow these steps to unlock it')}
              </p>
            </div>
          </div>

          <div className="mt-4 flex flex-col gap-6 rounded-[16px] bg-[#F5FAFF] p-3 lg:mt-8 lg:gap-6 lg:p-4">
            {[
              {
                step: '1',
                content: (
                  <>
                    {t('Apple locked step 1 prefix')}
                    <a
                      href={UNLOCK_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="break-all text-[#2405F2] underline"
                    >
                      {UNLOCK_URL}
                    </a>
                    {t('Apple locked step 1 suffix')}
                  </>
                ),
              },
              { step: '2', content: t('Apple locked step 2') },
              { step: '3', content: t('Apple locked step 3') },
            ].map(item => (
              <div key={item.step} className="flex items-start gap-3">
                <span className="flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full bg-[#6586FF] text-[15px] leading-[22px] text-white">
                  {item.step}
                </span>
                <p className="min-w-0 flex-1 break-words text-[15px] leading-[22px] text-[#353746]">{item.content}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-col items-center gap-4">
            <button
              type="button"
              className="w-full rounded-[40px] bg-[#FFCF55] px-10 py-2.5 text-[14px] font-medium leading-5 text-[#020417] lg:w-[240px]"
              onClick={() => window.open(UNLOCK_URL, '_blank', 'noopener,noreferrer')}
            >
              {t('Unlock on Apple')}
            </button>
            <button
              type="button"
              className="w-full rounded-[40px] border border-[#454CFF] px-10 py-2.5 text-[14px] font-medium leading-5 text-[#454CFF] lg:w-[240px]"
              onClick={onReverify}
            >
              {t('Unlocked, Reverify')}
            </button>
            <button
              type="button"
              className="text-[14px] font-medium leading-5 text-[#1C1E53]/60"
              onClick={onContactUs}
            >
              {t('Contact Us')}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  )
}

export default AppleIdLockedModal
